import { z } from "zod";

export const ProjectUiStatus = {
  DECLINED: "DECLINED",
  EXPIRED: "EXPIRED",
  CLOSED: "CLOSED",
  IN_REVIEW: "IN_REVIEW",
  APPROVED: "APPROVED",
} as const;
export type ProjectUiStatusType = (typeof ProjectUiStatus)[keyof typeof ProjectUiStatus];

export const projectUiStatusSchema = z.enum([
  ProjectUiStatus.DECLINED,
  ProjectUiStatus.EXPIRED,
  ProjectUiStatus.CLOSED,
  ProjectUiStatus.IN_REVIEW,
  ProjectUiStatus.APPROVED,
]);
